// import getRpcUrl from '~/utils/getRpcUrl'

/*
const RPC_URL = getRpcUrl()

export const simpleRpcProvider = new ethers.providers.JsonRpcProvider(RPC_URL)

export default null */


const activeWeb3Instance = {}

export const getProvider = (chainId: number, isAny = false) => {
    if (!activeWeb3Instance[chainId]) {
        // const RPC_URL = getRpcUrl(chainId)
        activeWeb3Instance[chainId] = null // new ethers.providers.JsonRpcProvider(RPC_URL, isAny ? null : chainId)
    }
    return activeWeb3Instance[chainId]
}
